import { FC } from 'react';
import { FormControl, FormLabel } from 'react-bootstrap';
import FormGroup from 'components/FormGroup';
import { SameDeliveryAndResidence } from 'components/forms/DeliveryAddress';
import { printf } from 'utils/i18n';
import { BaseHomeAddressProps } from '../../type';

export interface BaseAddressProps extends BaseHomeAddressProps {
    addressDisabled?: boolean; // 是否禁用地址
    postalDisabled?: boolean; // 是否禁用邮编
    hideMailAddress?: boolean; // 是否隐藏邮寄地址与居住地址不一致勾选框，默认展示
}

const BaseAddress: FC<BaseAddressProps> = props => {
    const { disabled, addressDisabled, postalDisabled, hideMailAddress, label = __('永久居住地址'), prefix } = props;
    const disabledAddress = addressDisabled ?? disabled;
    const disabledPostal = postalDisabled ?? disabled;

    return (
        <>
            {label && <FormLabel>{label}</FormLabel>}
            <FormGroup
                label={__('Province/State')}
                name={`${prefix}_state`}
                checker={value => {
                    if (disabledAddress) {
                        return true;
                    }

                    if (!value) {
                        return __('请输入省份/州');
                    }

                    if (!value.match(/^[a-zA-Z0-9 ./-]*'?[a-zA-Z0-9 ./-]*$/)) {
                        return __('You have entered the wrong format.');
                    }

                    if (value.length > 40) {
                        return printf(__('省份/州过长，不超过%s个字符'), 40);
                    }

                    return true;
                }}>
                <FormControl disabled={disabledAddress} placeholder={__('请输入省份/州')} />
            </FormGroup>
            <FormGroup
                label={__('City')}
                name={`${prefix}_city`}
                checker={value => {
                    if (disabledAddress) {
                        return true;
                    }

                    if (!value) {
                        return __('请输入城市');
                    }

                    if (!value.match(/^[a-zA-Z0-9 ./-]*'?[a-zA-Z0-9 ./-]*$/)) {
                        return __('You have entered the wrong format.');
                    }

                    if (value.length > 40) {
                        return printf(__('城市过长，不超过%s个字符'), 40);
                    }

                    return true;
                }}>
                <FormControl disabled={disabledAddress} placeholder={__('请输入城市')} />
            </FormGroup>
            <FormGroup
                label={__('Detailed Address')}
                name={`${prefix}_detail`}
                checker={value => {
                    if (disabledAddress) {
                        return true;
                    }

                    if (!value) {
                        return __('请输入详细地址');
                    }

                    if (!value.match(/^[a-zA-Z0-9 ./-]*'?[a-zA-Z0-9 ./-]*$/)) {
                        return __('You have entered the wrong format.');
                    }

                    if (value.length > 180) {
                        return printf(__('详细地址过长，不超过%s个字符'), 180);
                    }

                    return true;
                }}>
                <FormControl disabled={disabledAddress} placeholder={__('请输入详细地址')} />
            </FormGroup>
            {/* 邮政编码 */}
            <FormGroup
                name={`${prefix}_postal`}
                label={__('Postal')}
                checker={value => {
                    if (disabledPostal) {
                        return true;
                    }

                    if (!value) {
                        return __('请输入邮政编码');
                    }

                    if (!value.match(/^[a-zA-Z0-9 ./-]*'?[a-zA-Z0-9 ./-]*$/)) {
                        return __('You have entered the wrong format.');
                    }

                    return true;
                }}>
                <FormControl disabled={disabledPostal} placeholder={__('请输入邮政编码')} />
            </FormGroup>
            {!hideMailAddress && <SameDeliveryAndResidence disabled={disabled} />}
        </>
    );
};

export default BaseAddress;
